<div
  class="welcome-message-container w-full flex flex-col justify-center items-center text-white font-bold"
>
  <h1 class="text-6xl md:text-[80px] mt-3">{{ 'welcome-animation.welcome' | translate }}</h1>
  <p class="text-center text-base p-6 md:p-0 md:text-xl step-one md:w-full">
    {{ 'welcome-animation.message' | translate }}
  </p>
</div>
